import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FieldDefinition,
  PanelDefinition,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

@Component({
  selector: 'atx-attributes-panel',
  templateUrl: './attributes-panel.component.html',
  styleUrls: ['./attributes-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttributesPanelComponent {
  /** The data object to be used to render the attributes */
  @Input() public data: { [key: string]: unknown };

  /** A PanelDefinition containing the list of fieldDefinitions with the name of the attributes to be rendered */
  @Input() public componentDef: PanelDefinition;

  /**
   * Used to track the fields by it's name
   */
  public trackByFieldName(_: number, { name }: FieldDefinition) {
    return name;
  }

  /**
   * returns true if the data is not defined
   */
  public get isDataEmpty(): boolean {
    return (
      !this.data ||
      !this.componentDef ||
      !this.componentDef.fields ||
      !this.componentDef.fields.some((fieldDef) => {
        return !!(this.getFieldValue(fieldDef.name) ?? '').toString();
      })
    );
  }

  /**
   * Returns the value for a field
   * @param fieldName
   */
  public getFieldValue(fieldName: string) {
    // any is needed here because the component doesn't know the structure beforehand
    // tslint:disable-next-line: no-any
    return [this.data, ...fieldName.split('.')].reduce((ac: any, c: string) => {
      return ac[c];
    });
  }
}
